import "./style/index.scss";
import dayjs from "dayjs";
import { Button, Col, Divider, Form, Row, Select, Space, Image, DatePicker, UploadFile, Modal, Input, Checkbox, Flex } from "antd";
import { setModalCadastrarNotasFiscais } from "../../../../redux/slices/notasfiscais/notasFiscaisSlice";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { useEffect, useState } from "react";
import { CheckOutlined, CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { DetalhesSorteioModel } from "../../../../models/sorteio/detalhesSorteioModel";
import Upload, { RcFile, UploadProps } from "antd/es/upload";
import { NumericFormat } from "react-number-format";
import { realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { PrestacaoContaModel } from "../../../../models/prestacaoConta/prestacaoContaModel";
import { AnexoJsonConsignatarioModel } from "../../../../models/prestacaoConta/anexoJsonConsignatarioModel";
import { listarSorteio } from "../../../../services/sorteioService";
import { cadastrarPrestacaoContaConsignatario } from "../../../../services/prestacaoContaService";
import { buscarVendaConsignatario } from "../../../../services/vendaConsignatarioService";
import { VendaConsignatarioModel } from "../../../../models/vendaConsignatario/vendaConsignatarioModel";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";

dayjs.locale("pt-br");

type CadastroNotasFiscaisProps = {
  idEmpresa: number | null;
  idSorteio: number | null;
};

const CadastroNotasFiscais = ({ idEmpresa, idSorteio }: CadastroNotasFiscaisProps) => {
  //estados globais
  const notasFiscaisState = useAppSelector((state) => state.notasFiscais);
  const sorteioState = useAppSelector((state) => state.sorteio);
  const empresaState = useAppSelector((state) => state.empresa);
  const vendaConsignatarioState = useAppSelector((state) => state.vendaConsignatario);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const [cnjpChecked, setCnpjChecked] = useState<boolean>(false);
  const [chekedList, setCheckedList] = useState<any[]>([]);

  const [previewOpenEntidade, setPreviewOpenEntidade] = useState<boolean>(false);
  const [previewEntidade, setPreviewEntidade] = useState<string>("");
  const [imgEntidade, setImgEntidade] = useState<UploadFile[]>([]);
  const [imgEntidade64, setImgEntidade64] = useState<string>("");

  const [previewOpenCap, setPreviewOpenCap] = useState<boolean>(false);
  const [previewCap, setPreviewCap] = useState<string>("");
  const [imgCap, setImgCap] = useState<UploadFile[]>([]);
  const [imgCap64, setImgCap64] = useState<string>("");

  useEffect(() => {
    //Quando tiver selecionado somente empresa na tela principal
    if (idEmpresa !== null && idSorteio === null) {
      form.setFieldValue("idEmpresa", idEmpresa);
    }
    //Quando tiver selecionado empresa e sorteio na tela principal
    if (idSorteio !== null) {
      form.setFieldsValue({ idEmpresa: idEmpresa, idSorteio: idSorteio });
      var buscaConsig = { ...vendaConsignatarioState.busca };
      buscaConsig.idEmpresa = idEmpresa;
      buscaConsig.idSorteio = idSorteio;
      dispatch(buscarVendaConsignatario(buscaConsig));
    }
  }, []);

  const onChangeEmpresa = (value: number) => {
    dispatch(listarSorteio(value.toString()));
  };

  const onChangeSorteio = (value: number) => {
    var buscaConsig = { ...vendaConsignatarioState.busca };
    buscaConsig.idEmpresa = form.getFieldValue("idEmpresa");
    buscaConsig.idSorteio = value;
    dispatch(buscarVendaConsignatario(buscaConsig));
  };

  const uploadButton = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        border: "1px solid #d9d9d9",
        borderRadius: "3px",
        height: "32px",
        width: "156px",
        cursor: "pointer",
      }}
    >
      <UploadOutlined style={{ display: "block" }} />
      <div>Enviar Nota Fiscal</div>
    </div>
  );

  //retorna string de base64 para ser enviada para API
  const toBase64 = (img: any, callback: any) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  //função auxiliar para preview de imagem do upload
  const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const onChangeCancelEntidade = () => setPreviewOpenEntidade(false);

  const onChangeCancelCap = () => setPreviewOpenCap(false);

  const onChangePreviewEntidade = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }
    setPreviewEntidade(file.url || (file.preview as string));
    setPreviewOpenEntidade(true);
  };

  const onChangePreviewCap = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }
    setPreviewCap(file.url || (file.preview as string));
    setPreviewOpenCap(true);
  };

  const onChangeEntidade: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    if (newFileList[0] !== undefined) {
      toBase64(newFileList[0].originFileObj, (imageUrlResponse: any) => {
        setImgEntidade64(imageUrlResponse);
      });
    }
    setImgEntidade(newFileList);
  };

  const onChangeCap: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    if (newFileList[0] !== undefined) {
      toBase64(newFileList[0].originFileObj, (imageUrlResponse: any) => {
        setImgCap64(imageUrlResponse);
      });
    }
    setImgCap(newFileList);
  };

  const onChangeCheckbox = (list: number[]) => {
    setCheckedList(list);
  };

  const submit = (values: any) => {
    var arquivoJson: AnexoJsonConsignatarioModel[] = [
      {
        caminhoArquivo: imgEntidade64,
        extensaoArquivo: imgEntidade[0].type,
        idTipoArquivoAnexo: 5,
        nome: imgEntidade[0].name,
        valor: realParaNumber(values.valor),
        numeroNotaFiscal: values.numeroNotaFiscal,
      },
      {
        caminhoArquivo: imgCap64,
        extensaoArquivo: imgCap[0].type,
        idTipoArquivoAnexo: 4,
        nome: imgCap[0].name,
        valor: realParaNumber(values.valorCap),
        numeroNotaFiscal: values.numeroNotaFiscalCap,
      },
    ];

    var arquivo: PrestacaoContaModel = {
      idVendaConsignatario: null,
      idConsignatario: values.idConsignatario,
      dataTransacao: values.dataEmissao,
      idTipoArquivoAnexo: 0,
      prestacaoContaConsignatario: arquivoJson,
      idsConsignatario: chekedList.map((a: any) => {
        return { idConsignatario: a };
      }),
      idSorteio: values.idSorteio,
    };

    dispatch(
      cadastrarPrestacaoContaConsignatario({
        value: arquivo,
        busca: notasFiscaisState.busca,
        buscaAnexoPrestacao: {} as any,
        buscaAnexoVenda: {} as any,
        buscaVenda: {} as any,
        origem: "notasFiscais",
      })
    );
  };

  const voltar = () => {
    dispatch(setModalCadastrarNotasFiscais(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Empresa"
            name="idEmpresa"
            rules={[
              {
                required: true,
                message: "Selecione a empresa",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="labelSearch"
              placeholder="Selecione uma empresa"
              loading={empresaState.loading}
              onChange={onChangeEmpresa}
              style={{ width: 300 }}
              options={empresaState.list.map((a: EmpresaModel) => ({
                value: a.id,
                key: a.apelido,
                label: (
                  <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                    <div style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</div>
                    {a.apelido}
                  </Flex>
                ),
                labelSearch: a.apelido,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Sorteio"
            name="idSorteio"
            rules={[
              {
                required: true,
                message: "Selecione o sorteio",
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              loading={sorteioState.loadingEmpresas}
              onChange={onChangeSorteio}
              options={sorteioState.listSorteioEmpresas.map((a: DetalhesSorteioModel) => ({
                value: a.idSorteio,
                label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Data de emissão"
            name="dataEmissao"
            rules={[
              {
                required: true,
                message: "Selecione a data de emissão",
              },
            ]}
          >
            <DatePicker style={{ width: "100%" }} format={"DD/MM/YYYY"} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Consignatário"
            name="idConsignatario"
            rules={[
              {
                required: true,
                message: "Selecione o consignatário",
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              loading={vendaConsignatarioState.loading}
              disabled={vendaConsignatarioState.loading}
              optionFilterProp="label"
              options={vendaConsignatarioState.list
                .slice()
                .sort((a: VendaConsignatarioModel, b: VendaConsignatarioModel) => a.razaoConsignatario.trim().localeCompare(b.razaoConsignatario.trim()))
                .map((a: VendaConsignatarioModel) => ({
                  value: a.idConsignatario,
                  label: a.razaoConsignatario.trim(),
                }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Consignatários associados" name="grupoConsignatarios">
            <Checkbox style={{ marginBottom: "8px" }} onChange={(e) => setCnpjChecked(e.target.checked)}>
              Mostrar consignatários de mesmo CNPJ
            </Checkbox>
            <div className="checkboxContainer">
              {cnjpChecked ? (
                <Checkbox.Group
                  className="checkboxGroup"
                  options={vendaConsignatarioState.list
                    .slice()
                    .sort((a: VendaConsignatarioModel, b: VendaConsignatarioModel) => a.nomeConsignatario.localeCompare(b.nomeConsignatario))
                    .filter((a: VendaConsignatarioModel, index, self) => index === self.findIndex((b: VendaConsignatarioModel) => a.cpfCnpjConsignatario === b.cpfCnpjConsignatario))
                    .map((a: VendaConsignatarioModel) => ({
                      value: a.idConsignatario,
                      label: a.nomeConsignatario,
                    }))}
                  onChange={onChangeCheckbox}
                />
              ) : (
                <Checkbox.Group
                  className="checkboxGroup"
                  options={vendaConsignatarioState.list
                    .slice()
                    .sort((a: VendaConsignatarioModel, b: VendaConsignatarioModel) => a.nomeConsignatario.localeCompare(b.nomeConsignatario))
                    .map((a: VendaConsignatarioModel) => ({
                      value: a.idConsignatario,
                      label: a.nomeConsignatario,
                    }))}
                  onChange={onChangeCheckbox}
                />
              )}
            </div>
          </Form.Item>
        </Col>
        <Col span={12} style={{ marginTop: "-120px" }}>
          <Divider className="dividerNota" orientation="left">
            Nota Fiscal contra a Entidade
          </Divider>
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item
                label="Número da NF"
                name="numeroNotaFiscal"
                rules={[
                  {
                    required: true,
                    message: "Digite o número da nota fiscal",
                  },
                ]}
              >
                <Input style={{ width: "100%" }} type="text" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Valor"
                name="valor"
                rules={[
                  {
                    required: true,
                    message: "Digite o valor da nota fiscal",
                  },
                ]}
              >
                <NumericFormat
                  className="ant-input noBoderColor number-input"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  prefix="R$"
                  style={{ width: "100%" }}
                  fixedDecimalScale={true}
                  onChange={() => form.setFieldValue("valor", realParaNumber(form.getFieldValue("valor")))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={24}>
              <Upload
                action={"dummyRequest"}
                onChange={onChangeEntidade}
                beforeUpload={() => {
                  return false;
                }}
                fileList={imgEntidade}
                onPreview={onChangePreviewEntidade}
              >
                {imgEntidade.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal open={previewOpenEntidade} title={"Nota Fiscal Entidade"} footer={null} onCancel={onChangeCancelEntidade} destroyOnHidden>
                <img alt="" style={{ width: "100%" }} src={previewEntidade} />
              </Modal>
            </Col>
          </Row>
          <Divider className="dividerNota" orientation="left">
            Nota Fiscal contra a Capitalização
          </Divider>
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item
                label="Número da NF"
                name="numeroNotaFiscalCap"
                rules={[
                  {
                    required: true,
                    message: "Digite o número da nota fiscal",
                  },
                ]}
              >
                <Input style={{ width: "100%" }} type="text" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Valor"
                name="valorCap"
                rules={[
                  {
                    required: true,
                    message: "Digite o valor da nota fiscal",
                  },
                ]}
              >
                <NumericFormat
                  className="ant-input noBoderColor number-input"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  prefix="R$"
                  style={{ width: "100%" }}
                  fixedDecimalScale={true}
                  onChange={() => form.setFieldValue("valorCap", realParaNumber(form.getFieldValue("valorCap")))}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={24}>
              <Upload
                action={"dummyRequest"}
                onChange={onChangeCap}
                beforeUpload={() => {
                  return false;
                }}
                fileList={imgCap}
                onPreview={onChangePreviewCap}
              >
                {imgCap.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal open={previewOpenCap} title={"Nota Fiscal Capitalização"} footer={null} onCancel={onChangeCancelCap} destroyOnHidden>
                <img alt="" style={{ width: "100%" }} src={previewCap} />
              </Modal>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              SALVAR
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroNotasFiscais;
